/*
  List.js - Cost Centres List View Component
*/

// NPM
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';

// COMPONENTS
import Loader from '../../common/Loader';
import Paginator from '../../common/Paginator';

// CONFIG
import Config from '../../../Config';

// I18N
import formattedMessages from '../../../messages/account/CostCenterFormattedMessages';

const CostCentersTable = ({
  list = [],
  handleCostCentreClick,
  handleContactClick,
  isLoading = false,
}) => {
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLength, setPageLength] = useState(Config.defaultPL);

  const sortList = (data) => {
    return [...data].sort((a, b) => {
      if (a.cost_centre_name < b.cost_centre_name) return -1;
      if (a.cost_centre_name > b.cost_centre_name) return 1;
      return 0;
    });
  };

  const handlePageChange = (newPage) => {
    setPageNumber(newPage);
  };

  const handlePageLengthChange = (event) => {
    const newLength = parseInt(event.target.value, 10);
    setPageLength(newLength);
    setPageNumber(1);
  };

  const renderCostCenterTable = () => {
    if (isLoading) {
      return (
        <TableRow>
          <TableCell colSpan={3} sx={{ textAlign: 'center', py: 4 }}>
            <Loader />
          </TableCell>
        </TableRow>
      );
    }

    if (!list || list.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={3} sx={{ paddingY: 2 }}>
            <Typography>No results found.</Typography>
          </TableCell>
        </TableRow>
      );
    }

    const sortedList = sortList(list);
    const startIndex = (pageNumber - 1) * pageLength;
    const endIndex = startIndex + pageLength;
    const paginatedList = sortedList.slice(startIndex, endIndex);

    return paginatedList.map((costCenter, index) => (
      <TableRow
        key={costCenter.cost_centre_id || index}
        tabIndex={0}
        hover
        onClick={() => handleCostCentreClick(costCenter)}
      >
        <TableCell>{costCenter.cost_centre_name}</TableCell>
        <TableCell>{costCenter.contact_name}</TableCell>
        <TableCell>
          {costCenter.user_count > 0 ? costCenter.user_count : '0'}
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <TableContainer
        sx={{ marginBottom: 4, overflowX: 'auto', whiteSpace: 'nowrap' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{formattedMessages.name}</TableCell>
              <TableCell>{formattedMessages.contact}</TableCell>
              <TableCell>{formattedMessages.numberOfUsers}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderCostCenterTable()}</TableBody>
        </Table>
      </TableContainer>

      <Paginator
        pageNumber={pageNumber}
        itemCount={list.length}
        pageLength={pageLength}
        changeEvent={handlePageChange}
        editFunction={handlePageLengthChange}
        disabled={isLoading}
        showTotal="Cost Centers Found"
      />
    </>
  );
};

export default CostCentersTable;
